import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalCopilotSendMessageDocument = gql`
  mutation SalesPortalCopilotSendMessage($text: String!, $sessionId: String) {
    salesPortalCopilotSendMessage(text: $text, session_id: $sessionId) {
      session_id
      messages {
        text
        timestamp
      }
    }
  }
`;
export type SalesPortalCopilotSendMessageMutationFn = Apollo.MutationFunction<
  Types.SalesPortalCopilotSendMessageMutation,
  Types.SalesPortalCopilotSendMessageMutationVariables
>;
export function useSalesPortalCopilotSendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalCopilotSendMessageMutation,
    Types.SalesPortalCopilotSendMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalCopilotSendMessageMutation,
    Types.SalesPortalCopilotSendMessageMutationVariables
  >(SalesPortalCopilotSendMessageDocument, options);
}
export type SalesPortalCopilotSendMessageMutationHookResult = ReturnType<
  typeof useSalesPortalCopilotSendMessageMutation
>;
export type SalesPortalCopilotSendMessageMutationResult =
  Apollo.MutationResult<Types.SalesPortalCopilotSendMessageMutation>;
export type SalesPortalCopilotSendMessageMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalCopilotSendMessageMutation,
    Types.SalesPortalCopilotSendMessageMutationVariables
  >;
